
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';
import { useTranslations } from 'use-intl';
import { useEffect, useState } from 'react';
import { autoLoginInDev } from '@/utils/devAutoLogin';

const Index = () => {
  const t = useTranslations('consultantOnboarding.app');
  const { user, loading } = useAuth();
  const [devLoginAttempted, setDevLoginAttempted] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const attemptDevLogin = async () => {
      if (!loading && !user && !devLoginAttempted) {
        setDevLoginAttempted(true);
        await autoLoginInDev();
      }
    };

    attemptDevLogin();
  }, [user, loading, devLoginAttempted]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen gap-2">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-muted-foreground">{t('loading')}</p>
      </div>
    );
  }

  if (!user) {
    console.log("Index: No user, redirecting to /auth");
    // Preserve query params when redirecting to auth (for OAuth errors)
    return <Navigate to={`/auth${location.search}`} replace />;
  }

  console.log("Index: User authenticated, redirecting to /overview");
  return <Navigate to="/overview" replace />;
};

export default Index;
